import Input, { InputWrapper, Label } from 'components/Form/Input'
import Select from 'components/Form/Select'
import I18n from 'components/I18n'
import { UsStateType } from 'data/types'
import messages from 'lang'
import React from 'react'
import { WrappedComponentProps } from 'react-intl'

type Props = {
  addressLine1: string
  addressLine2: string
  city: string
  isPostalCodeValid: boolean
  isSupported: boolean
  postalCode: string
  setAddressLine1: (string) => void
  setAddressLine2: (string) => void
  setCity: (string) => void
  setPostalCode: (string) => void
  setUsState: (string) => void
  usState: string
  usStates: UsStateType[]
} & WrappedComponentProps

const UsFields = ({
  addressLine1,
  addressLine2,
  city,
  intl,
  isPostalCodeValid,
  isSupported,
  postalCode,
  setAddressLine1,
  setAddressLine2,
  setCity,
  setPostalCode,
  setUsState,
  usState,
  usStates
}: Props) => (
  <>
    <InputWrapper>
      <Label htmlFor='kyc-us-state'>
        <I18n data={messages.label_state} />
      </Label>
      <Select name='kyc-us-state' onChange={(e) => setUsState(e.target.value)} value={usState}>
        {usStates.map((c) => (
          <option key={c.code} value={c.code}>
            {c.name}
          </option>
        ))}
      </Select>
    </InputWrapper>
    {isSupported && (
      <>
        <InputWrapper>
          <Label htmlFor='kyc-address'>
            <I18n data={messages.label_first_line_us} />
          </Label>
          <Input
            name='kyc-address1'
            onChange={(val) => setAddressLine1(val)}
            value={addressLine1}
            placeholder={intl.formatMessage(messages.placeholder_first_line_us)}
          />
          <Input
            name='kyc-address2'
            onChange={(val) => setAddressLine2(val)}
            value={addressLine2}
            placeholder={intl.formatMessage(messages.placeholder_second_line_us)}
          />
        </InputWrapper>
        <InputWrapper>
          <Label htmlFor='kyc-city'>
            <I18n data={messages.label_city} />
          </Label>
          <Input name='kyc-city' onChange={(val) => setCity(val)} value={city} />
        </InputWrapper>
        <InputWrapper>
          <Label htmlFor='kyc-zip'>
            <I18n data={messages.label_zipcode} />
          </Label>
          <Input
            hasError={!isPostalCodeValid && postalCode !== ''}
            name='kyc-zip'
            onChange={(val) => setPostalCode(val)}
            value={postalCode}
          />
        </InputWrapper>
      </>
    )}
  </>
)

export default UsFields
